import { render } from "./RequiredInputPhone.vue?vue&type=template&id=acaeea2e&ts=true"
import script from "./RequiredInputPhone.vue?vue&type=script&lang=ts"
export * from "./RequiredInputPhone.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
